export const UPDATE_COMPANY_ADMIN_USER =
  '[company] UPDATE OBJECT COMPANY ADMIN USER';

export const updateObjectCompanyAdminUser = (data) => ({
  type: UPDATE_COMPANY_ADMIN_USER,
  payload: data,
});
